import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricLose extends MetricBase {
    constructor() {
        super({
            field: "metric_lose_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.lose.chartName"),
            serieLabel: i18n.t("metrics.trivago.lose.serieLabel"),
            tooltip: i18n.t("metrics.trivago.lose.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricLose;
